import React from 'react'

const Head = () => {
    return (
        <section className="flat-title ">
            <div className="tf-container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="title-inner ">
                            <ul className="breadcrumb">
                                <li><a className="home fw-6 text-color-3" href="/">Home</a></li>
                                <li>Our Properties</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Head